var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-title',{attrs:{"title":"Home page"}}),(_vm.doneLoading)?_c('div',[(_vm.currentUser.userType === 'YP')?_c('y-p-home'):_vm._e(),(['SW', 'PA'].includes(_vm.currentUser.userType))?_c('s-w-p-a-home'):_vm._e()],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }